<div class="accordion-tab" *ngIf="isBrowser" [ngClass]="{ 'mb-3': !isHomepage || !showCarousel }">
  <p-accordion class="text-center" (onClose)="onTabClose()" (onOpen)="onTabOpen()">
    <p-accordionTab header="{{ 'MENU.STREAMING' | translate }}">
      <div *ngIf="channelEmbedType === 'iframe'" style="width:100.01%; height: 484px;">
        <iframe [src]="url" style="border: none" width="100%" height="100%">
        </iframe>
      </div>

      <div [ngStyle]="{
          display: channelEmbedType !== 'iframe' ? 'block' : 'none'
        }">
        <video id="my-video" class="video-js" controls preload="auto" data-setup="{}">
          <source [src]="url" type="application/x-mpegURL" />
        </video>
      </div>

      <div class="container-fluid bg-black streaming-carousel">
        <div class="row justify-content-around py-4">
          <p-carousel [value]="channels" [circular]="true" [numVisible]="5" [numScroll]="1"
            [responsiveOptions]="responsiveOptions" [indicatorsContentClass]="'d-none'">
            <ng-template let-channel pTemplate="image">
              <a class="c-p" (click)="
                  startVideo(
                    channel?.channelStreamSource,
                    channel?.channelEmbedType
                  )
                ">
                <img class="channel-img rounded-lg" [src]="channel?.channelIcon" />
              </a>
            </ng-template>
          </p-carousel>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>
  <div *ngIf="isBrowser && showCarousel && isHomepage" [@enterAnimation] class="hideArrow">
    <p-carousel [value]="sliders" [autoplayInterval]="5000" [circular]="true">
      <ng-template let-slide pTemplate="image">
        <a [ngStyle]="{ cursor: slide.page_url ? 'pointer' : 'default' }"
          [routerLink]="slide.page_url ? 'race/' + slide.page_url : '/'">
          <img class="img-fluid" [src]="slide.image_url" [alt]="slide.alt | translateDataByLanguage" />
        </a>
      </ng-template>
    </p-carousel>
  </div>
</div>